import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";

export default styled(Accordion)(({ theme, ownerState }) => {
    const { palette } = theme;
    const { color, darkMode } = ownerState;
    const { white, text, grey } = palette;

    let backgroundValue = palette[color] ? palette[color].main : white.main;
    let colorValue = white.main;

    if (!darkMode && (color === "white" || color === "light" || !palette[color])) {
        colorValue = text.main;
    } else if (darkMode && (color === "white" || color === "light" || !palette[color])) {
        colorValue = grey[600];
        backgroundValue = '#1a2035';
    }

    return {
        backgroundColor: backgroundValue,
        color: colorValue,
        borderRadius: "6px",
        margin: "8px 0",
        "& .MuiAccordion-root": {
            fontWeight: "bold",
            color: colorValue,
            backgroundColor: backgroundValue,
            boxShadow: 'none'
        },
        "& .MuiAccordionSummary-root": {
            fontWeight: "bold",
            color: colorValue,
            backgroundColor: backgroundValue,
            fontSize: '1rem'
        },
        "& .MuiAccordionSummary-content": {
            fontWeight: "bold",
            color: darkMode ? '#fff' : grey[600],
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
            fontWeight: "bold",
            color: darkMode ? '#fff' : grey[600],
        },
        "& .MuiAccordionDetails-root": {
            padding: "16px",
        },
    };
});
